import { get, writable } from 'svelte/store';
import { PortalUserService } from '../../services/portal-user.service';
import { refreshUserSession, navigateToRoot } from '../../app.logic';
export const selfUser = writable(null);
export const changePasswordDto = writable(null);
export const passwordChangedMessage = writable('');
export async function initUserDetail() {
    selfUser.set(null);
    clearPasswordDto();
    let _resp = await PortalUserService.fetchSelf().toPromise();
    selfUser.set(_resp.payload);
}
export async function save() {
    let _record = get(selfUser);
    let _resp = await PortalUserService.saveSelf(_record).toPromise();
    selfUser.set(_resp.payload);
    // realod auth user data and refresh app header
    await refreshUserSession();
    navigateToRoot();
}
export async function changePassword() {
    let _record = get(changePasswordDto);
    clearPasswordDto();
    try {
        await PortalUserService.selfChangePassword(_record).toPromise();
        passwordChangedMessage.set('Password modificata');
    }
    catch (issue) {
        switch (issue.code) {
            case 'NEW_PASS_MISMATCH':
                passwordChangedMessage.set('Le nuove password non corrispondono');
                break;
            case 'OLD_PASS_MISMATCH':
                passwordChangedMessage.set('La vecchia password non corrisponde');
                break;
            default:
                passwordChangedMessage.set('Si è verificato un errore, riprovare in seguito');
        }
    }
}
export function describeRole(roleCode) {
    switch (roleCode) {
        case 'ADM':
            return 'Amministratore';
        case 'OPR':
            return 'Operatore';
        default:
            return '';
    }
}
function clearPasswordDto() {
    passwordChangedMessage.set('');
    changePasswordDto.set({
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
    });
}
